var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive az_crud_tb nd_table_radius"},[_c('table',{staticClass:"table",class:_vm.tableClass},[_c('thead',[(_vm.$slots.hasOwnProperty('head'))?_vm._t("head"):_vm._e()],2),_c('tbody',[(_vm.$slots.hasOwnProperty('body'))?_vm._t("body"):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }